"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChartQueryBuilderPlugin = exports.PieChartQueryBuilder = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const StyledConfigFieldControl = (0, styled_components_1.default)(core_ui_1.ConfigFieldControl) `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const PieChartQueryBuilder = props => {
    var _a, _b;
    const { type, params } = props;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const index = (((_b = (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.pluginConfigs) || []).findIndex(pluginConfig => pluginConfig.type === type);
    const update = (updateParams = {}) => {
        queryManager.updatePluginConfig(index, {
            type: exports.PieChartQueryBuilderPlugin.type,
            params: Object.assign(Object.assign({}, params), updateParams)
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, clearOnBlur: true, clearOnEscape: true, value: params.field || null, options: queryManager.queryAliasColumnMap.map(columnMap => columnMap.path), onChange: (_, value) => {
                    params.field = value || undefined;
                    update();
                }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Select Field' }))) }),
            react_1.default.createElement(core_1.FormHelperText, null, "Select the field value to be displayed on the chart")),
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(core_1.TextField, { type: 'number', fullWidth: true, size: 'small', variant: 'outlined', label: 'Chart Height', value: params.chartHeight, onChange: event => {
                    const value = event.target.value
                        ? parseInt(event.target.value)
                        : undefined;
                    params.chartHeight = value;
                    update();
                } }),
            react_1.default.createElement(core_1.FormHelperText, null, "Custom Chart Height (Default: 300px)")),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Show Legends', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.showLegends, onChange: () => {
                        params.showLegends = !params.showLegends;
                        update();
                    } }) })),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Show Percentage', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.showPercentage, onChange: () => {
                        params.showPercentage = !params.showPercentage;
                        update();
                    } }) })),
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Exclude Null Valuess', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.excludeNullValues, onChange: () => {
                        params.excludeNullValues = !params.excludeNullValues;
                        update();
                    } }) })),
        react_1.default.createElement(StyledConfigFieldControl, null,
            react_1.default.createElement(core_1.FormControlLabel, { label: 'For Workflow Status', control: react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!params.forWorkflowStatus, onChange: () => {
                        params.forWorkflowStatus = !params.forWorkflowStatus;
                        update();
                    } }) }),
            react_1.default.createElement(core_1.FormHelperText, null, "Enable the parsing of Task Status values"))));
};
exports.PieChartQueryBuilder = PieChartQueryBuilder;
exports.PieChartQueryBuilderPlugin = {
    name: 'Pie Chart',
    type: 'PieChart',
    component: exports.PieChartQueryBuilder
};
//# sourceMappingURL=PieChartQueryBuilderPlugin.js.map